import { i18n } from "@lingui/core";
import en from "../locales/en/messages.js";

i18n.load("en", en.messages);
i18n.activate("en");

export { i18n };
